import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { Notify, PersonelLogin } from '../models/Personel';
import { NotifymodalComponent } from '../notifymodal/notifymodal.component';
import { AuthService } from '../services/auth.service';
import { PersonelService } from '../services/personel.service';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.css']
})
export class MessagesComponent implements OnInit {

  user: PersonelLogin;
  displayedColumns: string[];
  dataSource: any;
  isAdmin: boolean;

  constructor(
    public personelService: PersonelService,
    public authService: AuthService,
    private spinner: NgxSpinnerService,
    public dialog:MatDialog,
  ) {

    this.user = this.authService.getLoginDetails();


    this.refreshTable();
  }

  ngOnInit(): void {
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  checkNot(not:Notify){
    this.personelService.checkReadMessage(not.Id).subscribe(res => {

            this.dialog.open(NotifymodalComponent, {
              data: {
                isSuccess: true,
                text: "MESAJ GÖNDERİLDİ",
                subject: "Mesaj Okuma"
              }
            }).afterClosed().subscribe(() => {
              this.refreshTable();
            });
    },
      error => {
        this.dialog.open(NotifymodalComponent, {
          data: {
            isSuccess: false,
            text: error.error.error,
            subject: "Mesaj Okuma"
          }
        });
      });
  }

  refreshTable() {

    this.spinner.show();

    if (this.user.user_role == "Admin") {
      //console.log("ADMIN");
      this.isAdmin = true;
      this.personelService.getMessagesAdmin().subscribe(res => {
        //console.log(res);
        this.displayedColumns = ['CreateDate', 'UserNameSurname', 'Caption', 'Message', 'IsRead', 'IsReadDate'];
        this.dataSource = new MatTableDataSource(res);
        this.spinner.hide();
      });

    } else {
      this.isAdmin = false;
      //console.log("USER");
      this.personelService.getMessageNotify().subscribe(res => {
        this.displayedColumns = ['CreateDate','Caption', 'Message', 'IsRead', 'IsReadDate','Op'];
        this.dataSource = new MatTableDataSource(res);
        this.spinner.hide();
      });


    }
  }
}
